import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
	withStyles,
	Button,
	Grid,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Link,
	Typography,
	Select,
	MenuItem,
	InputAdornment,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Tooltip,
	ClickAwayListener
} from '@material-ui/core';
import {
	sortUsers,
	getSavedTableSettings,
	getTableStyleProps,
	encodeUser,
	sortTable
} from 'utils/users';
import { writeUserSettings } from 'redux/modules/session';
import { Scrollbars } from 'react-custom-scrollbars';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import {
	addOfficeId,
	clearConnectMlsState,
	clearErrorsForConnectionAndUser,
	addAgentMlsId,
	deleteAgentMlsId,
	editAgentMlsId
} from 'redux/modules/mls';
import classNames from 'classnames';
import { hideModal, resetModal } from 'redux/modules/modal';
import { showErrorPopup } from 'redux/modules/companies';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import { 
	XIcon,
	SpinnerIcon,
	SearchIcon,
	ClearSearchIcon,
	IconMlsIdDone,
	SortArrow,
	Info,
	IconAddUsers,
	IconInfoRounded
} from '../../theme/icons';
import _ from 'lodash';
import ERRORS from '../../errors/errorids';
import {
	trackManageAgentMlsPopupShown,
	trackManageAgentMlsPopupAddUsers,
	trackMlsConfirmAgentValidity
} from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';
import { openIntercomChat } from 'utils/intercom';
import { USER_TABLE_MANAGE_AGENTS, TABLE_COLUMNS, SORT_ORDER, } from '../../config';
import { getMlsFormProps, focusSelect } from 'utils/forms';
import { MLS_ERRORS } from 'utils/mls';

import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const invalidMLSInputValue = {
	['invalid-value'] : 'users-table-mls-id-invalid-value',
	['already-used'] : 'users-table-mls-id-already-used',
};

const SCREEN_TYPE = {
	USERS_LIST: 'USERS_LIST',
	CHECK_AGENT_ID_VALIDITY: 'CHECK_AGENT_ID_VALIDITY',
};

const styles = theme => {
	return {
		...getMlsFormProps(theme),

		/* Dialog */
		dialogPaper: {
			minWidth: 960,
			[theme.breakpoints.down('sm')]: {
				minWidth: '90%'
			}
		},
		dialogWrapper: {
			position: 'relative',
			padding: '15px 10px 0',
			minHeight: 400,
			display: 'flex',
			flexDirection: 'column'
		},

		/* dialog content */
		dialogContentUserList: {
			minHeight: 610,
			overflow: 'visible',
		},		

		dialogContentCheckValidity: {
			minHeight: 530,
			overflow: 'visible',
		},				

		/* loading icon */
		loadingContainer: {
			minHeight: 680,
			position: 'relative'
		},
		/* mls system and search */
		mlsSystemAndSearchContainer: {
			justifyContent: 'space-between',
		},
		mlsSystemFieldContainer: {
			marginBottom: 23,
		},
		mlsSelect: {
			minWidth: '362px',
			maxWidth: '450px',
			textAlign: 'left',
			'& div[class*="selectMenu"]': {
				paddingTop: 9,
				paddingBottom: 9
			}
		},
		mlsSelectedValue: {
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		},
		mlsSelectOption: {
		},
		searchFieldContainer: {
			marginBottom: 23,
		},

		/* input field */
		field: {
			margin: 0,

			'& input': {
				width: 225,
				borderRadius: 20,
				border: '1px solid rgba(153, 153, 153, 0.32)',
				boxShadow: `1px 1px 3px ${theme.palette.colors.colorWithAlpha(theme.palette.common.black, 0.16)}`,
				color: theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta, 0.75),
				padding: '13px 40px 12px 15px',

				fontFamily: 'Open Sans, sans-serif',
				fontWeight: 'normal',
				fontStyle: 'normal',
				fontSize: '13px',
				lineHeight: '14px',				

				'&:focus, &:hover': {
					color:'#2888c3',
					borderColor:'#2888c3'
				},				

				'&::placeholder': {
					fontFamily: 'Open Sans, sans-serif',
					fontWeight: 'normal',
					fontStyle: 'normal',
					fontSize: '13px',
					lineHeight: '14px',
					color: theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta, 0.75),
				}
			},

			'& textarea': {
				width: '425px',
				display: 'block',
			},

			'& [id*=helper-text]': {
				paddingLeft: 0,
				color: theme.palette.error.main
			},

			'& [class*=error] input': {
				borderColor: `${theme.palette.error.main} !important`
			}
		},
		inputAdornment: {
			position: 'absolute',
			top: '50%',
			right: 7,
			transform: 'translateY(-50%)'
		},

		introMessage: {
			marginBottom: 23,
			textAlign: 'left',
			'& p:not(:last-child)': {
				marginBottom: 20
			},
			'& p': {
				fontSize: '16px',
				lineHeight: '22px',
				opacity: 1
			}
		},

		...getTableStyleProps(USER_TABLE_MANAGE_AGENTS, theme),
		
		/* user table */
		tableWrapper: {
			width: 'calc(100% + 15px)',
			overflow: 'hidden'
		},
		connectionStatus: {
			padding: '3px 8px',
			fontFamily: 'Open Sans, sans-serif',
			fontWeight: 'bold',
			fontStyle: 'normal',
			fontSize: '12px',
			lineHeight: '14px',
			borderRadius: 10,
			opacity: 1,
			display: 'inline-block'
		},
		connectionStatusConnected: {
			background: '#BEFAC8',
			color: '#287A0C'
		},
		connectionStatusNotConnected: {
			background: '#BFBFBF',
			color: theme.palette.common.black
		}
	};
};

@withStyles(styles)
class ManageMlsAgentsModal extends Component {

	constructor(props) {
		super(props);

		this.inputRefs = {};
		this.scrollbarRef = React.createRef(null);

		const stateFromProps = this.getStateFromProps(props);
		const companyUsers = stateFromProps.users;

		this.hideAllMlsFields = this.hideAllMlsFields.bind(this);
		this.cleanMlsIdValue = this.cleanMlsIdValue.bind(this);
		this.clickAwayHandler = this.clickAwayHandler.bind(this);
		this.handleScrollStart = this.handleScrollStart.bind(this);

		let searchTerm = '';
		let usersToRender;
		let showingSearchResults;
		let mlsSystem = null;

		if (this.props.preselectUserId) {
			usersToRender = companyUsers.filter(u => u.userId === this.props.preselectUserId);
			if (usersToRender.length) {
				showingSearchResults = true;
				searchTerm = usersToRender[0].name;

				// find first connectionId for this user to avoid preselecting connection where user does not have record
				const preselectedAgentRecord = this.props.mls.agentsMlsIds.find(
					conn => conn.userId === this.props.preselectUserId
				);

				const preselectConnectionId = _.get(preselectedAgentRecord, 'mlsConnectionId');

				if (preselectConnectionId) {
					mlsSystem = this.props.connections.find(item => item.mlsConnectionId === preselectConnectionId);
				} else {
					// no mls connection for this user in any MLS board
					mlsSystem = this.props.connections[0];
				}
				
			} else {
				showingSearchResults = false;
				mlsSystem = this.props.connections[0];
			}
			
		} else {
			// when modal is opened from mls-connection section
			usersToRender = companyUsers;
			showingSearchResults = false;
			mlsSystem = this.props.connections.find(item => item.mlsConnectionId === this.props.mlsConnectionId);
		}

		const newExternalId = this.getNewExternalId();
		const shownMlsFields = {};
		shownMlsFields[mlsSystem.mlsConnectionId] = {};

		const focusedField = {};
		let focusFieldOnMount;

		if (this.props.usersPage &&
				this.props.preselectUserId &&
				mlsSystem.mlsConnectionId &&
				this.props.selfStartMlsIdsForUser.length < 2) {

			shownMlsFields[mlsSystem.mlsConnectionId][this.props.preselectUserId] = true;
			focusedField[mlsSystem.mlsConnectionId] = {};
			focusedField[mlsSystem.mlsConnectionId][this.props.preselectUserId] = true;

			focusFieldOnMount = `input-mls-${mlsSystem.mlsConnectionId}-${this.props.preselectUserId}`;
		} else if (!this.props.usersPage && usersToRender.length === 1 &&
			!newExternalId[mlsSystem.mlsConnectionId][usersToRender[0].userId]) {

			shownMlsFields[mlsSystem.mlsConnectionId][usersToRender[0].userId] = true;
			focusFieldOnMount = `input-mls-${mlsSystem.mlsConnectionId}-${usersToRender[0].userId}`;
		}

		this.state = {
			...stateFromProps,
			currentStep: SCREEN_TYPE.USERS_LIST,
			mlsSystem,
			dropdownOpened: this.props.usersPage && this.props.selfStartMlsIdsForUser.length > 1,
			preselectUserId: this.props.preselectUserId,
			usersToRender,

			// sorting
			sortKey: getSavedTableSettings(this.props.settings, USER_TABLE_MANAGE_AGENTS, 'sortKey'),
			sortOrder: getSavedTableSettings(this.props.settings, USER_TABLE_MANAGE_AGENTS, 'sortOrder'),

			// search
			searchTerm,
			showingSearchResults,

			// mls ID related
			focusFieldOnMount,
			newExternalId,
			shownMlsFields,
			focusedField,
			mlsFieldsWithErrors: {},
			updatingMlsIdForUsers: {},
		};

		this.handleOpenIntercom = this.handleOpenIntercom.bind(this);
	}

	getStateFromProps(props) {
		const { rawDataById, selectedId } = props.companies;
		const company = rawDataById[selectedId];
		const { users } = company;
		return { users };
	}

	componentWillReceiveProps(nextProps) {
		const selectedConnectionId = this.state.mlsSystem.mlsConnectionId;

		this.setState({
			...this.getStateFromProps(nextProps),
		});

		if (this.state.currentStep === SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY) {
			if (
				(!_.isEqual(this.props.mls.addingAgentMlsIdSuccess, nextProps.mls.addingAgentMlsIdSuccess)
					&&
					nextProps.mls.addingAgentMlsIdSuccess.find(item => item.mlsConnectionId === selectedConnectionId)
				)
				||
				(!_.isEqual(this.props.mls.editingAgentMlsIdSuccess, nextProps.mls.editingAgentMlsIdSuccess)
					&&
					nextProps.mls.editingAgentMlsIdSuccess.find(item => item.mlsConnectionId === selectedConnectionId))
			) {
				this.setState({
					currentStep: SCREEN_TYPE.USERS_LIST,
				});
			}
		}

		if (
			(!_.isEqual(this.props.mls.addingAgentMlsIdErrorId, nextProps.mls.addingAgentMlsIdErrorId)
				&&
				nextProps.mls.addingAgentMlsIdErrorId.find(item => item.mlsConnectionId === selectedConnectionId)
			)
			||
			(!_.isEqual(this.props.mls.editingAgentMlsIdErrorId, nextProps.mls.editingAgentMlsIdErrorId)
				&&
				nextProps.mls.editingAgentMlsIdErrorId.find(item => item.mlsConnectionId === selectedConnectionId))
		) {
			this.handleApiErrors(nextProps);
		}		
	}

	render() {
		const { modalShown, resetModal, classes } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				BackdropProps={{ style: { backgroundColor: 'rgba(46, 63, 79, 0.4)' } }}
				classes={{ paper: classes.dialogPaper }}
				PaperProps={{
					style: {
						border: 0,
						width: 309,
						borderRadius: 5,
						boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)'
					}
				}}
			>
				<div className={classes.dialogWrapper}>
					<IconButton
						className={classNames({
							[classes.closeDialog]: true,
							['closeDialog']: true
						})}															
						component='span'
						aria-label='Close'
						onClick={() => this.closeDialog()}
					>
						<XIcon className={classes.closeDialogIcon} />
					</IconButton>
					
					{(() => {
						if (this.state.currentStep === SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY && (
							this.props.mls.addingAgentMlsIdXhrInProgress.length ||
							this.props.mls.editingAgentMlsIdXhrInProgress.length
						)) {
							return this.renderLoading();
						} else if (this.state.currentStep === SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY) {
							return this.renderCheckAgentIdValidity();
						} else {
							return this.renderContent();
						}
					})()}

				</div>
			</Dialog>
		);
	}

	closeDialog() {
		this.props.onClose(false /*shouldReloadList*/);
	}

	handleConfirmMlsId() {
		trackMlsConfirmAgentValidity(getTrackingOptions(this.props.company));
		const agentIdsWithError = this.getAgentIdsToConfirmRemoval();
		
		for (let i = 0; i < agentIdsWithError.length; i++) {
			this.updateExternalIdForUser(
				agentIdsWithError[i].userId,
				agentIdsWithError[i].mlsConnectionId,
				agentIdsWithError[i].agentMlsId || agentIdsWithError[i].newAgentMlsId,
				true /* forceAddition */
			);
		}
	}

	handleRemoveMlsId() {
		const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);
		updatingMlsIdForUsers[this.state.mlsSystem.mlsConnectionId] = {};

		const shownMlsFields = _.clone(this.state.shownMlsFields);
		shownMlsFields[this.state.mlsSystem.mlsConnectionId] = {};

		this.setState({
			shownMlsFields,
			updatingMlsIdForUsers,
			currentStep: SCREEN_TYPE.USERS_LIST,
		});
		
		this.resetPreviousAPIMessageFieldValue();
		this.props.clearConnectMlsState();
	}

	getAgentIdsToConfirmRemoval() {
		const selectedConnectionId = this.state.mlsSystem.mlsConnectionId;
		const agentIdsWithError = [];

		this.props.mls.addingAgentMlsIdErrorId.forEach(item => {
			if (
				item => item.mlsConnectionId === selectedConnectionId &&
					item.errorId === ERRORS.AGENT_NO_LISTINGS_FOUND	&&
					item.forceAddition === false
			) {
				agentIdsWithError.push(item);
			}
		});
		this.props.mls.editingAgentMlsIdErrorId.forEach(item => {
			if (
				item => item.mlsConnectionId === selectedConnectionId &&
					item.errorId === ERRORS.AGENT_NO_LISTINGS_FOUND &&
					item.forceAddition === false
			) {
				agentIdsWithError.push(item);
			}
		});

		return agentIdsWithError;
	}

	renderCheckAgentIdValidity() {
		const { classes } = this.props;
		const headerIcon = <IconInfoRounded className={classNames(classes.headerIcon, classes.headerIconInfo)} />;
		const popupTitle = localize('mls-error-manage-agents-screen-title-no-listings-found');

		const agentIdsWithError = this.getAgentIdsToConfirmRemoval().map(item => item.agentMlsId || item.newAgentMlsId);
		const errorMessage = localize('mls-error-manage-agents-no-listings-found',
				[agentIdsWithError.join(','), this.state.mlsSystem.name]);
		
		const forceAdditionErrorMessages = this.getForceAdditionErrorMessage();

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					{headerIcon} {popupTitle}
				</DialogTitle>
				<DialogContent className={classes.dialogContentCheckValidity} >
					<Grid container direction="column">
						{forceAdditionErrorMessages.length > 0 && forceAdditionErrorMessages}

						<Grid item className={classNames(classes.failureMessage, classes.feedbackMessage)}>
							<Typography
								variant="body2"
								dangerouslySetInnerHTML={{ __html: errorMessage }} />

							{forceAdditionErrorMessages.length > 0 && this.renderContactForHelp()}
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Grid
						item
						container
						direction="row"
						justify="flex-end"
						className={classes.buttonsContainer}>

						<Button
							variant='outlined'
							color='primary'
							data-tid="button-remove-mls-id-form"
							className={classNames(classes.button, classes.buttonBack)}
							onClick={() => this.handleRemoveMlsId()}
						>
							{localize('mls-error-screen-remove-mls-id')}
						</Button>
						<Button
							variant='contained'
							color='primary'
							data-tid="button-confirm-agent-mls-id"
							className={classNames(classes.button, classes.buttonPrimary)}
							onClick={() => this.handleConfirmMlsId()}
						>
							{localize('mls-error-screen-confirm')}
						</Button>
					</Grid>
				</DialogActions>
			</Fragment>
		);		
	}	

	renderLoading() {
		const { classes } = this.props;
		return (
			<div className={classes.loadingContainer}>
				<div className={classes.loadingContent}>
					<SpinnerIcon className={classes.loadingIcon} />
					<Typography className={classes.loadingMessage} variant="body2">
						{localize('mls-popup-saving-form')}
					</Typography>
				</div>
			</div>
		);
	}

	getForceAdditionErrorMessage() {
		const { classes } = this.props;
		const result = [];
		const forceAdditionRequestErrors = [];
		const selectedConnectionId = this.state.mlsSystem.mlsConnectionId;

		this.props.mls.addingAgentMlsIdErrorId.forEach(item => {
			if (
				item.mlsConnectionId === selectedConnectionId &&
				item.forceAddition
			) {
				forceAdditionRequestErrors.push(item);
			}
		});

		this.props.mls.editingAgentMlsIdErrorId.forEach(item => {
			if (
				item.mlsConnectionId === selectedConnectionId &&
				item.forceAddition
			) {
				forceAdditionRequestErrors.push(item);
			}
		});

		forceAdditionRequestErrors.forEach(item => {
			const errorMessageKey = item.errorId && MLS_ERRORS[item.errorId] || MLS_ERRORS[ERRORS.UNKNOWN];
			const errorMessage = localize('mls-error-manage-agents-no-listings-found-force-addition',
				[item.agentMlsId || item.newAgentMlsId, item.mlsConnectionId]);		

			result.push(
				<Typography
					className={classes.errorMessage}
					variant="body2"
					dangerouslySetInnerHTML={{ __html: `${errorMessage} ${localize(errorMessageKey)}`}}
				/>
			);
		});

		return result;
	}

	handleOpenIntercom() {
		openIntercomChat(null, true, this.props.showErrorPopup);
	}

	renderContent() {
		const { classes } = this.props;
		const { searchTerm, mlsSystem, dropdownOpened } = this.state;
		const selectedConnectionId = this.state.mlsSystem.mlsConnectionId;
		const isSelectDisabled = this.props.connections.length === 1 ||
			(
				// disable dropdown while loading, otherwise on very slow connection response might 
				// arrive after user changes this.state.mlsSystem using dropdown
				this.props.mls.addingAgentMlsIdXhrInProgress.find(item => item.mlsConnectionId === selectedConnectionId) ||
				this.props.mls.editingAgentMlsIdXhrInProgress.find(item => item.mlsConnectionId === selectedConnectionId) ||
				this.props.mls.deletingAgentMlsIdXhrInProgress.find(item => item.mlsConnectionId === selectedConnectionId)
			);

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					{localize('mls-manage-agents-popup-header')}
				</DialogTitle>
				<DialogContent className={classes.dialogContentUserList} >
					<Grid container direction="column">

						{!this.props.usersPage && (
							<Grid item className={classes.introMessage}>
								<Typography variant="body2">
									<Link
										className={classNames({
											[classes.introMessageLink]: true,
											['introMessageLink']: true
										})}									
										onClick={() => this.handleAddUserToTeam()}	
									>
										{localize('mls-manage-agents-popup-add-users-1')}
									</Link>&nbsp;
									{localize('if they are not yet in the team.')}
								</Typography>
							</Grid>
						)}

						<Grid container direction="row" className={classes.mlsSystemAndSearchContainer}>
							<Grid item className={classes.mlsSystemFieldContainer}>

								<Select
									disabled={isSelectDisabled}
									className={classes.mlsSelect}
									id="select-mls-system"
									value={mlsSystem}
									open={dropdownOpened}
									native={false}
									displayEmpty={true}
									renderValue={(option) => {
										if (option) {
											return (<div className={classes.mlsSelectedValue}>{option.name}</div>);	
										} else {
											return (
												<div className={classes.mlsSelectedValue}>
													{localize('mls-please-select-mls-connection')}
												</div>
											);	
										}
									}}
									disableUnderline
									IconComponent={SelectArrow}
									onChange={(event) => this.handleConnectionDropdownChange(event)}
									onOpen={() => this.handleConnectionDropdownOpen()}
									onClose={() => this.handleConnectionDropdownClose()}
								>
									{this.props.connections.map((option, index) => (
										<MenuItem className={classes.mlsSelectOption} key={option.mlsConnectionId} value={option}>
											<div>{option.name}</div>
										</MenuItem>
									))}
								</Select>
							</Grid>
							<Grid item className={classes.searchFieldContainer}>
								<Grid item className={classes.textFieldWrapper}>
									{this.textField(
											'searchTerm',
											searchTerm,
											localize('mls-search-for-agent-placeholder'),
											null,
											null,
											null,
											false,
											this.state.showingSearchResults
												?
												(
													<Tooltip
														placement="top"
														title={
															<Fragment>
																<Typography
																	variant='body2'
																	className={classes.infoTooltipText}
																>
																	{localize('mls-clear-search')}
																</Typography>
																<span className={classes.tooltipArrow} />
															</Fragment>
														}
														classes={{
															tooltip: classes.infoTooltip
														}}
													>
														<ClearSearchIcon />
													</Tooltip>								
												)
												:
												<SearchIcon />
									)}
								</Grid>
							</Grid>
						</Grid>

						{this.renderUserTable(USER_TABLE_MANAGE_AGENTS, this.state.newExternalId)}
					</Grid>
				</DialogContent>
			</Fragment>
		);
	}

	handleAddUserToTeam() {
		trackManageAgentMlsPopupAddUsers(getTrackingOptions(this.props.company));

		const pathName = `${location.origin}/#${this.props.company.id}/users?show-add-users-modal=1`;
		window.open(pathName, '_blank');
	}

	handleConnectionDropdownChange(event) {
		this.setState({
			mlsSystem: event.target.value
		});
	}

	handleConnectionDropdownOpen() {
		this.setState({
			dropdownOpened: true
		});
	}

	handleConnectionDropdownClose() {
		this.setState({
			dropdownOpened: false
		});
	}

	getCompanyUsers() {
		const { rawDataById, selectedId } = this.props.companies;
		const company = rawDataById[selectedId];
		const { users } = company;
		return users;
	}

	renderUserTable(tableId, externalIds) {
		const { classes } = this.props;
		const { sortKey, sortOrder } = this.state;

		let usersToRender = this.state.usersToRender.map((user) => {
			const originalExternalIdValue = this.getOriginalMlsIdForAgent(this.state.mlsSystem.mlsConnectionId, user.userId) ;
			return {
				...user,
				mlsConnected: Boolean(originalExternalIdValue),
				originalAgentMlsId: originalExternalIdValue
			};
		});

		usersToRender = sortUsers(usersToRender, sortKey, sortOrder);

		return (
			<div className={classes.tableWrapper}>
				<Table className={classes.table}>
					<TableHead>
						<TableRow className={classes.tableHeadRow}>
							<TableCell
								padding='dense'
								className={classNames(
											classes.noBorderedCell,
											classes.tableNameCellHeader,
											classes.tableCellHeader,
											classes.tableHasSortArrow
								)}>
								<IconButton
									className={classNames({
										[classes.sortArrow]: true,
										['sortArrow']: true,
										['desc']: sortKey === TABLE_COLUMNS.FULL_NAME &&
													sortOrder === SORT_ORDER.DESC,
										['active']: sortKey === TABLE_COLUMNS.FULL_NAME
									})}
									component='span'
									aria-label={localize('users-table-change-sorting-order')}
									onClick={() =>
										sortTable(this, tableId, TABLE_COLUMNS.FULL_NAME, this.props.writeUserSettings)}
								>
									<SortArrow className={classes.sortArrowIcon} />
								</IconButton>
								{localize('users-table-header-name')}
							</TableCell>
							<TableCell
								padding='dense'
								className={classNames(
											classes.noBorderedCell,
											classes.tableEmailCellHeader,
											classes.tableCellHeader,
											classes.tableHasSortArrow)}>
								<IconButton
									className={classNames({
										[classes.sortArrow]: true,
										['sortArrow']: true,
										['desc']: sortKey === TABLE_COLUMNS.EMAIL && sortOrder === SORT_ORDER.DESC,
										['active']: sortKey === TABLE_COLUMNS.EMAIL
									})}
									component='span'
									aria-label={localize('users-table-change-sorting-order')}
									onClick={() => sortTable(this, tableId, TABLE_COLUMNS.EMAIL, this.props.writeUserSettings)}
								>
									<SortArrow className={classes.sortArrowIcon} />
								</IconButton>											
								{localize('users-table-header-email')}
							</TableCell>
							<TableCell
								padding='none'
								className={classNames(
									classes.tableMLSCellHeader,
									classes.noBorderedCell,
									classes.tableCellHeader,
									classes.tableHasSortArrow
								)}
							>
								<IconButton
									className={classNames({
										[classes.sortArrow]: true,
										['sortArrow']: true,
										['desc']: sortKey === TABLE_COLUMNS.MLS_ID_TYPE2 &&
											sortOrder === SORT_ORDER.DESC,
										['active']: sortKey === TABLE_COLUMNS.MLS_ID_TYPE2
									})}
									component='span'
									aria-label={localize('users-table-change-sorting-order')}
									onClick={() => sortTable(
										this,
										tableId,
										TABLE_COLUMNS.MLS_ID_TYPE2,
										this.props.writeUserSettings)
									}
								>
									<SortArrow className={classes.sortArrowIcon} />
								</IconButton>								

								<p className={classes.tableMLSCellHeaderLabel}>
									{localize('users-table-header-mls')}
								</p>

								<Tooltip
									placement="top"
									title={
										<Fragment>
											<Typography
												variant='body2'
												className={classNames(classes.infoTooltipText, classes.infoTooltipCentered)}
												dangerouslySetInnerHTML={{ 
													__html: localize('users-table-header-mls-tooltip-agents-modal')
												}} 
											/>
											<span className={classes.tooltipArrow} />
										</Fragment>
									}
									classes={{
										tooltip: classes.infoTooltip
									}}
								>
									<IconButton
										className={classes.infoIconButton}
										color='primary'
										component='span'
										disableRipple
									>
										<Info />
									</IconButton>														
								</Tooltip>
							</TableCell>
							<TableCell
								padding='dense'
								className={classNames(
											classes.noBorderedCell,
											classes.tableConnectionStatusCellHeader,
											classes.tableCellHeader,
											classes.tableHasSortArrow
								)}>
								<IconButton
									className={classNames({
										[classes.sortArrow]: true,
										['sortArrow']: true,
										['desc']: sortKey === TABLE_COLUMNS.CONNECTION_STATUS &&
													sortOrder === SORT_ORDER.DESC,
										['active']: sortKey === TABLE_COLUMNS.CONNECTION_STATUS
									})}
									component='span'
									aria-label={localize('users-table-change-sorting-order')}
									onClick={() => 
										sortTable(this, tableId, TABLE_COLUMNS.CONNECTION_STATUS, this.props.writeUserSettings)}
								>
									<SortArrow className={classes.sortArrowIcon} />
								</IconButton>
								{localize('users-table-header-connection-status')}
							</TableCell>
						</TableRow>
					</TableHead>
				</Table>						
						
				<Scrollbars
					ref={this.scrollbarRef}
					style={{ height: 410 }}
					autoHide={false}
					onScrollStart={this.handleScrollStart}
					renderThumbVertical={({ style, ...props }) =>
						(<div
							{...props}
							style={{
								...style,
								width: 8,
								backgroundColor: '#6F99BD',
								opacity: 0.5,
								borderRadius: 4
							}}/>)
					}
				>
					<ClickAwayListener onClickAway={this.clickAwayHandler}>
						<Table className={classes.table} onMouseLeave={() => this.hideAllMlsFields(false, true)}>
							<TableBody>
								{
									usersToRender.length === 0
										?
										(
											<Fragment>
												<TableRow 
													key={'user-not-found'}
													hover
													className={classNames({
														[classes.tableBodyRow]: true,
													})}
												>
													<TableCell
														padding='dense'
														colSpan={4}
														className={classNames(
															classes.tableCellBody, classes.tableNotFoundCellBody
														)}
													>
														<Typography variant='body1' className={classes.noUsersFound}>
															{localize('mls-agents-table-no-users-found')}
														</Typography>
														<Button
															variant='contained'
															data-tid="button-user-add"
															color='primary'
															onClick={() => this.handleAddUserToTeam()}
															className={classNames({
																[classes.buttonAddUsers]: true,
																['buttonAddUsers']: true
															})}															
														>
															<IconAddUsers className={classes.iconAddUsers} />
															{localize('mls-agents-table-add-user-to-team')}
														</Button>

													</TableCell>
												</TableRow>
											</Fragment>
										)
										:
										this.renderUserRows(usersToRender, externalIds)
								}
							</TableBody>
						</Table>
					</ClickAwayListener>
				</Scrollbars>						
			</div>						
		);		
	}	

	handleScrollStart() {
		this.hideAllMlsFields();
	}

	clickAwayHandler(e) {
		const target = e.target.nodeType === Node.TEXT_NODE ? e.target.parentElement : e.target;
		const isAddUserButton = target.closest('.introMessageLink') ||
			target.closest('.buttonAddUsers') ||
			target.closest('.closeDialog');

		if (isAddUserButton) return;		

		this.hideAllMlsFields(true);
	}

	getOriginalMlsIdForAgent(mlsConnectionId, userId, props,) {
		const agentRecord = (props || this.props).mls.agentsMlsIds.find(
			conn => conn.userId === userId && conn.mlsConnectionId === mlsConnectionId
		);
		const originalExternalIdValue = _.get(agentRecord, 'agentMlsId', '');
		return originalExternalIdValue;
	}

	getMongoAgentId(mlsConnectionId, userId) {
		const agentRecord = this.props.mls.agentsMlsIds.find(
			conn => conn.userId === userId && conn.mlsConnectionId === mlsConnectionId
		);
		
		return _.get(agentRecord, '_id');
	}

	renderUserRows(usersToRender, externalIds) {
		const { mlsSystem } = this.state;
		const { currentUserEmail, classes } = this.props;

		return usersToRender.map((user, index) => {
			const { name, email, userId } = encodeUser(user);
			const key = `user-row-${index}`;

			return (
				<TableRow 
					key={key}
					hover
					className={classNames({
						[classes.tableBodyRow]: true,
					})}
				>
					<TableCell padding='dense' className={classNames(classes.tableCellBody, classes.tableNameCellBody)}>
						{(currentUserEmail === email) ? localize('users-table-name-you', name) : name}
					</TableCell>
					<TableCell padding='dense' className={classNames(classes.tableCellBody, classes.tableEmailCellBody)}>
						{email}
					</TableCell>
					{this.renderMLSCell(
						userId,
						this.state.mlsSystem.mlsConnectionId,
						this.state.newExternalId[mlsSystem.mlsConnectionId][userId])
					}
					<TableCell
						padding='dense'
						className={
							classNames(classes.tableCellBody, classes.tableConnectionStatusCellBody)
						}>
						
						{
							user.mlsConnected
								?
								(
									<Typography 
										className={classNames(classes.connectionStatusConnected, classes.connectionStatus)} 
										variant="body2">
										{localize('users-table-mls-connected')}
									</Typography>
								)
								:
								(
									<Typography
										className={classNames(classes.connectionStatusNotConnected, classes.connectionStatus)}
										variant="body2">
										{localize('users-table-mls-not-connected')}
									</Typography>
								)
						}

					</TableCell>
				</TableRow>
			);
		}, this);
	}

	componentDidMount() {
		trackManageAgentMlsPopupShown(getTrackingOptions(this.props.company));

		if (this.state.focusFieldOnMount) {
			setTimeout(() => {
				this.inputRefs[this.state.focusFieldOnMount].current &&
					focusSelect(this.inputRefs[this.state.focusFieldOnMount].current);
			}, 250);
		}
	}

	getNewExternalId() {
		const newExternalId = {}; 
		const companyUsers = this.getCompanyUsers();

		this.props.connections.forEach((currentConnection) => {
			companyUsers.forEach((currentUser) => {

				if (currentUser.userId) {
					const originalExternalIdValue =
						this.getOriginalMlsIdForAgent(currentConnection.mlsConnectionId, currentUser.userId);

					if (!newExternalId[currentConnection.mlsConnectionId]) {
						newExternalId[currentConnection.mlsConnectionId] = {};
					}

					newExternalId[currentConnection.mlsConnectionId][currentUser.userId] = originalExternalIdValue;
				}
			});
		});

		return newExternalId;
	}

	componentDidUpdate(prevProps) {
		const { rawDataById: rawDataByIdPrev, selectedId: selectedIdPrev } = prevProps.companies;
		const companyPrev = rawDataByIdPrev[selectedIdPrev];
		const { users: usersPrev } = companyPrev;
		const usersUpdated = this.getCompanyUsers();

		if (!_.isEqual(usersPrev, usersUpdated)) {
			if (this.state.showingSearchResults) {
				this.setState(this.getSearchResults());
			} else {
				this.setState({
					usersToRender: this.state.users
				});
			}
		}

		usersUpdated.forEach((updatedUser, index) => {
				
			const oldUser = usersPrev.find(u => u.email === updatedUser.email);

			if (oldUser) {

				this.props.connections.forEach(({mlsConnectionId}) => {

					const newExternalIdValue = this.getOriginalMlsIdForAgent(mlsConnectionId,
						oldUser.userId,
						this.props);

					const previousExternalIdsValue = this.getOriginalMlsIdForAgent(
						mlsConnectionId,
						oldUser.userId,
						prevProps);

					if (newExternalIdValue !== previousExternalIdsValue) {

						if (
							(
								!_.isEqual(
										this.props.mls.addingAgentMlsIdSuccess,
										prevProps.mls.addingAgentMlsIdSuccess) &&
									this.props.mls.addingAgentMlsIdSuccess.find(item =>
										item.userId === updatedUser.userId && item.mlsConnectionId === mlsConnectionId)	
							) ||
							(
								!_.isEqual(
										this.props.mls.editingAgentMlsIdSuccess,
										prevProps.mls.editingAgentMlsIdSuccess) &&
									this.props.mls.editingAgentMlsIdSuccess.find(item =>
										item.userId === updatedUser.userId && item.mlsConnectionId === mlsConnectionId)	
							) ||
							(
								!_.isEqual(
										this.props.mls.deletingAgentMlsIdSuccess,
										prevProps.mls.deletingAgentMlsIdSuccess) &&
									this.props.mls.deletingAgentMlsIdSuccess.find(item => 
										item.userId === updatedUser.userId && item.mlsConnectionId === mlsConnectionId)	
							)
						) {

							let shouldUpdateState = false;

							if (!_.isEqual(_.omit(
								updatingMlsIdForUsers, [`[${mlsConnectionId}][${updatedUser.userId}]`]
							), this.state.updatingMlsIdForUsers)) {
								shouldUpdateState = true;
							}						
							shouldUpdateState = true;

							const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);
							if (_.get(updatingMlsIdForUsers, `[${mlsConnectionId}][${updatedUser.userId}]`)) {
								delete updatingMlsIdForUsers[mlsConnectionId][updatedUser.userId];
							}
							
							const shownMlsFields = _.clone(this.state.shownMlsFields);
							if (_.get(shownMlsFields, `[${mlsConnectionId}][${updatedUser.userId}]`)) {
								delete shownMlsFields[mlsConnectionId][updatedUser.userId];
							}
							
							const focusedField = _.clone(this.state.focusedField);
							if (_.get(focusedField, `[${mlsConnectionId}][${updatedUser.userId}]`)) {
								delete focusedField[mlsConnectionId][updatedUser.userId];
							}

							const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
							if (_.get(mlsFieldsWithErrors, `[${mlsConnectionId}][${updatedUser.userId}]`)) {
								delete mlsFieldsWithErrors[mlsConnectionId][updatedUser.userId];
							}

							// update existing external id record for current user
							if (shouldUpdateState) {
								this.setState({ updatingMlsIdForUsers, shownMlsFields, focusedField, mlsFieldsWithErrors });
							}
						}
					}

				});
			} else if (updatedUser.userId) {
				// initialize to default (empty string) for users added in new tab
				const newExternalId = _.clone(this.state.newExternalId);

				this.props.connections.forEach(({mlsConnectionId}) => {
					const originalExternalIdValue =
						this.getOriginalMlsIdForAgent(mlsConnectionId, updatedUser.userId);

					if (!newExternalId[mlsConnectionId]) {
						newExternalId[mlsConnectionId] = {};
					}

					newExternalId[mlsConnectionId][updatedUser.userId] = originalExternalIdValue;
					this.setState({ newExternalId });
				});
			}
		});

		// delete "updating" indicator for user and focus field
		if (
			this.state.currentStep === SCREEN_TYPE.USERS_LIST &&
			(
				!_.isEmpty(this.props.mls.addingAgentMlsIdErrorId) ||
				!_.isEmpty(this.props.mls.editingAgentMlsIdErrorId) ||
				!_.isEmpty(this.props.mls.deletingAgentMlsIdErrorId)				
			)
		) {
			const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);

			this.props.connections.forEach(({mlsConnectionId}) => {
				if (updatingMlsIdForUsers[mlsConnectionId]) {
					Object.keys(updatingMlsIdForUsers[mlsConnectionId]).map(currentUserId => {

						const apiError = this.getApiErrorForUserAndConnection(currentUserId, mlsConnectionId);

						if (apiError) {
							if (_.get(this.state.updatingMlsIdForUsers, `[${mlsConnectionId}][${currentUserId}]`)) {
								const shownMlsFields = _.clone(this.state.shownMlsFields);
								if (!shownMlsFields[mlsConnectionId]) {
									shownMlsFields[mlsConnectionId] = {};
								}
								shownMlsFields[mlsConnectionId][currentUserId] = true;
									
								delete updatingMlsIdForUsers[mlsConnectionId][currentUserId];
								this.setState({ updatingMlsIdForUsers, shownMlsFields });
							}
						}
					});
				}
			});
		}
	}	

	renderContactForHelp() {
		return (
			<Typography variant="body2">
				<Link onClick={this.handleOpenIntercom}>
					{localize('mls-error-screen-contact-for-help-1')}
				</Link>&nbsp;
				{localize('mls-error-screen-contact-for-help-2')}
			</Typography>		
		);
	}

	handleApiErrors(nextProps) {
		const selectedConnectionId = this.state.mlsSystem.mlsConnectionId;

		if (
			this.state.currentStep === SCREEN_TYPE.USERS_LIST &&
			(
				(
					!_.isEqual(this.props.mls.addingAgentMlsIdErrorId, nextProps.mls.addingAgentMlsIdErrorId) &&
					nextProps.mls.addingAgentMlsIdErrorId.find(
						item => item.mlsConnectionId === selectedConnectionId &&
						item.errorId === ERRORS.AGENT_NO_LISTINGS_FOUND))
					||
					(!_.isEqual(this.props.mls.editingAgentMlsIdErrorId, nextProps.mls.editingAgentMlsIdErrorId) &&
					nextProps.mls.editingAgentMlsIdErrorId.find(item =>
						item.mlsConnectionId === selectedConnectionId && 
						item.errorId === ERRORS.AGENT_NO_LISTINGS_FOUND))
			)
		) {
			this.setState({
				currentStep: SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY
			});
		}
	}		

	textField(name, value, placeholder, disabled, type, maxLength, autosize, icon) {
		const { classes } = this.props;

		return (
			<FormField
				value={value}
				autoComplete='off'
				className={classes.field}
				data-tid={`form-user-${name}`}
				onChange={event => this.onTextFieldChange(event, name)}
				onKeyPress={event => this.onTextFieldKeyPress(event, name)}
				id={name}
				placeholder={placeholder}
				{...(type ? { type } : {})}
				{...(autosize ? { autosize } : {})}
				margin="normal"
				disabled={disabled}
				maxLength={maxLength}
				inputRef={this[name]}
				{...(icon ? { 
					inputProps: {
						endAdornment: (
							<InputAdornment position="end" className={classes.inputAdornment}>
								<IconButton
									aria-label="Search"
									onClick={() => this.handleSearchIconClick()}
								>
									{icon}
								</IconButton>
							</InputAdornment>
						)
					}
				} : {})}
			/>
		);
	}

	handleSearchIconClick() {
		if (this.state.showingSearchResults) {
			this.setState({
				searchTerm: '',
				showingSearchResults: false,
				preselectUserId: null,
				usersToRender: this.state.users
			});
		} else {
			this.setState(this.getSearchResults());
		}
	}

	onTextFieldKeyPress(event, name) {
		if (event.key === 'Enter') {
			this.setState(this.getSearchResults());
		}
	}

	getSearchResults() {
		return {
			preselectUserId: null,
			showingSearchResults: this.state.searchTerm !== '',
			usersToRender: 
				this.state.searchTerm === ''
					?
					this.state.users
					:
					this.state.users.filter(
						u => ((u.name || '').toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1 ||
						u.email.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1)
					)
		};
	}

	onTextFieldChange(event, name) {
		this.setFieldState(name, event.target.value);
	}

	setFieldState(fieldName, value) {
		let newState = _.cloneDeep(this.state);
		newState[fieldName] = value;
		this.setState(newState);
	}

	renderMLSCell(userId, mlsConnectionId, externalId) {
		const { classes } = this.props;

		if (!userId) {
			return (
				<TableCell
					padding='dense'
					className={classNames(classes.tableCellBody, classes.mlsPendingPrompt)}
				>
					{localize('user-table-mls-pending-prompt')}
				</TableCell>
			);
		}

		const apiError = this.getApiErrorForUserAndConnection(userId, mlsConnectionId);
		const errorMessageKey = apiError && apiError.errorId && MLS_ERRORS[apiError.errorId] || MLS_ERRORS[ERRORS.UNKNOWN];

		const renderCellContent = () => {

			const isUserUpdating = 
			this.props.mls.addingAgentMlsIdXhrInProgress.find(item => item.userId === userId &&
						item.mlsConnectionId === mlsConnectionId) ||
			this.props.mls.editingAgentMlsIdXhrInProgress.find(item => item.userId === userId &&
									item.mlsConnectionId === mlsConnectionId) ||
			this.props.mls.deletingAgentMlsIdXhrInProgress.find(item => item.userId === userId &&
									item.mlsConnectionId === mlsConnectionId)												;

			return _.get(this.state.updatingMlsIdForUsers, `[${mlsConnectionId}][${userId}]`)
				?
				this.renderMLSFieldContentUpdatingState(userId, externalId, mlsConnectionId)
				:
				_.get(this.state.shownMlsFields, `[${mlsConnectionId}][${userId}]`)
					?
					!isUserUpdating
						?
						this.renderMLSFieldContentInputField(userId, externalId, mlsConnectionId)//xxx
						:
						this.renderMLSFieldContentNonEditableValue(userId, externalId, mlsConnectionId)
					:
					externalId === ''
						?
						this.renderMLSFieldContentNoExternalId(userId, mlsConnectionId)
						:
						this.renderMLSFieldContentNonEditableValue(userId, externalId, mlsConnectionId);
		};

		return (
			<TableCell padding='dense' className={classes.tableCellBody}>
				{renderCellContent()}
				{apiError && (
					<Typography variant='body2' className={classNames(classes.externalIdsErrorMessage)}>
						{localize(errorMessageKey)}
					</Typography>
				)}
			</TableCell>
		);			
	}	

	renderMLSFormField(userId, externalId, mlsConnectionId) {
		const { classes } = this.props;
		const errorClasses = { error: classes.mlsErrorMessage };
		this.inputRefs[`input-mls-${mlsConnectionId}-${userId}`] = React.createRef();
		const errorMessageKey = _.get(this.state.mlsFieldsWithErrors, `[${mlsConnectionId}][${userId}]`);

		return (
			<Tooltip
				placement="top"
				open={!_.get(this.state.focusedField, `[${mlsConnectionId}][${userId}]`)}
				title={
					<Fragment>
						<Typography
							variant='body2'
							className={classNames({
								[classes.infoTooltipText]: true,
								[classes.mlsPendingPrompt]: !userId
							})}
						>
							{localize(userId ? 'users-table-enter-agent-mls-id' : 'user-table-mls-pending-prompt')}
						</Typography>
						<span className={classes.tooltipArrow} />
					</Fragment>
				}
				classes={{
					tooltip: classes.mlsInfoTooltipTableBody
				}}
			>
				<FormField
					value={externalId || ''}
					autoComplete='off'
					className={classNames(classes.mlsInputField)}
					data-tid={'mls-id-field'}
					onChange={event => this.onMLSFieldChange(event, userId, mlsConnectionId)}
					onKeyPress={event => this.onMLSFieldKeyPress(event, userId, mlsConnectionId)}
					onKeyDown={event => this.onMLSFieldBlur(event)}
					onFocus={event => this.onMLSFieldFocus(userId, mlsConnectionId)}
					margin="normal"
					id={`input-mls-${userId}-${mlsConnectionId}`}
					helperText={errorMessageKey && localize(errorMessageKey)}
					error={!!_.get(this.state.mlsFieldsWithErrors, `[${mlsConnectionId}][${userId}]`)}
					FormHelperTextProps={{ classes: errorClasses }}
					inputRef={this.inputRefs[`input-mls-${mlsConnectionId}-${userId}`]}
				/>
			</Tooltip>
		);
	}

	renderMLSFieldContentInputField(userId, externalId, mlsConnectionId) {
		const { classes } = this.props;

		const apiError = this.getApiErrorForUserAndConnection(userId, mlsConnectionId);
		const saveEnabled = this.isMLSSaveEnabled(userId, mlsConnectionId);
		const shouldRenderActionIcons = _.get(this.state.focusedField, `[${mlsConnectionId}][${userId}]`);

		return (
			<div
				key={`user-input-field-${mlsConnectionId}-${userId}`}
				onMouseEnter={() => this.showMLSField(userId, mlsConnectionId)}
				className={classes.singleMlsIdField}>
				<Grid container direction="row" className={classes.mlsIdFieldGrid}>
					<Grid item className={classes.mlsIdFieldWrapper}>
						{this.renderMLSFormField(userId, externalId, mlsConnectionId)}
					</Grid>
					<Grid item className={classes.mlsFieldActionIcon}>
						{
							(shouldRenderActionIcons || apiError) && (//show Save icon to enable resubmit
								<Tooltip
									placement="top"
									disableHoverListener={!saveEnabled || apiError}
									disableFocusListener={!saveEnabled || apiError}
									title={
										<Fragment>
											<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
												{localize('users-table-mls-id-done')}
											</Typography>
											<span className={classes.tooltipArrow} />
										</Fragment>
									}
									classes={{
										tooltip: classes.infoTooltip
									}}
								>
									<IconMlsIdDone
										className={classNames({
											[classes.mlsActionIcon]: true,
											[classes.mlsIconDone]: true,
											[classes.mlsIconEnabled]: saveEnabled,
											['mls-icon-hover']: saveEnabled,
											['mls-icon-done']: true
										})}
										onClick={(event) => saveEnabled && this.saveMLSFieldChanges(userId, mlsConnectionId)} 
									/>									
								</Tooltip>
							)
						}
					</Grid>
				</Grid>
			</div>		
		);
	}

	renderMLSFieldContentNoExternalId(userId, mlsConnectionId) {
		const { classes } = this.props;
		return (
			<div
				key={`user-no-external-id-${mlsConnectionId}-${userId}`}
				onMouseEnter={() => this.showMLSField(userId, mlsConnectionId)}
				className={classes.emptyExternalMlsId}
			>
				{localize(userId ? 'users-table-enter-agent-mls-id' : 'user-table-mls-pending-prompt')}
			</div>
		);
	}	

	renderMLSFieldContentNonEditableValue(userId, externalId, mlsConnectionId) {
		const { classes } = this.props;
		return (
			<div
				key={`user-non-editable-value-${mlsConnectionId}-${userId}`}
				onMouseEnter={() => this.showMLSField(userId, mlsConnectionId)}
				className={classes.nonEditableMlsIdValueNode}
			>
				{externalId}
			</div>
		);		
	}

	renderMLSFieldContentUpdatingState(userId, externalId, mlsConnectionId) {
		const { classes } = this.props;
		return (
			<div
				key={`user-updating-state-${mlsConnectionId}-${userId}`}
				className={classes.updatingMlsIdNode}
			>
				<Grid container direction="row" className={classes.updatingMlsUserGrid}>
					<Grid item className={classes.updatingMlsUserValue}>
						{externalId}
					</Grid>
					<Grid item className={classes.updatingMlsUserIcon}>
						<SpinnerIcon className={classes.updatingUserIcon} />
					</Grid>
				</Grid>
			</div>
		);
	}

	showMLSField(userId, mlsConnectionId) {
		const shownMlsFields = _.clone(this.state.shownMlsFields);

		Object.keys(shownMlsFields).map(currentmlsConnectionId => {
			Object.keys(shownMlsFields[currentmlsConnectionId]).map(currentUserId => {
				if (!_.get(this.state.focusedField, `[${currentmlsConnectionId}][${currentUserId}]`)) {
					delete shownMlsFields[currentmlsConnectionId][currentUserId];
				}
			});
		});

		if (!shownMlsFields[mlsConnectionId]) {
			shownMlsFields[mlsConnectionId] = {};
		}

		shownMlsFields[mlsConnectionId][userId] = true;

		this.setState({ shownMlsFields });
	}

	saveMLSFieldChanges(userId, mlsConnectionId) {
		const value = this.state.newExternalId[mlsConnectionId][userId];
		const newExternalId = _.clone(this.state.newExternalId);
		newExternalId[mlsConnectionId][userId] = value;

		this.setState({ newExternalId }, () => {
			this.updateExternalIdForUser(userId, mlsConnectionId, value);
		});
	}

	onMLSFieldChange(event, userId, mlsConnectionId) {
		this.validateMlsId(event.target.value, userId, mlsConnectionId);

		const newExternalId = _.clone(this.state.newExternalId);
		newExternalId[mlsConnectionId][userId] = event.target.value;
		this.setState({ newExternalId });

		// Clear API error mesassage when he edits field after ERROR.DUPLICATE_MLS_IDS error
		const apiError = this.getApiErrorForUserAndConnection(userId, mlsConnectionId);
		if (_.get(apiError, 'errorId') === ERRORS.AGENT_ID_EXISTS) {
			this.props.clearErrorsForConnectionAndUser(mlsConnectionId, userId);
		}
	}

	cleanMlsIdValue(val) {
		return val.toString().trim();
	}

	isMlsIdAlreadyUsed(id) {
		let result = false;
		const { mlsSystem } = this.state;
		const { mlsConnectionId } = mlsSystem;

		if (id === '') return result;

		const newExternalId = this.state.newExternalId[mlsConnectionId];
		Object.keys(newExternalId).forEach((currentUserId) => {
			if (newExternalId[currentUserId] === id) {
				result = true;
			}
		});

		return result;
	}

	validateMlsId(value, userId, mlsConnectionId) {
		const val = value.toString();
		const isIdAlreadyUsed = this.isMlsIdAlreadyUsed(val);
		if (val === '' || this.cleanMlsIdValue(val) === val && !isIdAlreadyUsed) {
			const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
			if (_.get(this.state.mlsFieldsWithErrors, `[${mlsConnectionId}][${userId}]`)) {
				delete mlsFieldsWithErrors[mlsConnectionId][userId];
			}
			
			this.setState({ mlsFieldsWithErrors });
			return true;
		} else {

			const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
			if (!mlsFieldsWithErrors[mlsConnectionId]) {
				mlsFieldsWithErrors[mlsConnectionId] = {};
			}
			
			mlsFieldsWithErrors[mlsConnectionId][userId] = isIdAlreadyUsed
				?
				invalidMLSInputValue['already-used']
				:
				invalidMLSInputValue['invalid-value'];
			this.setState({ mlsFieldsWithErrors });

			return false;
		}		
	}

	isMLSSaveEnabled(userId, mlsConnectionId) {
		const originalExternalId = this.getOriginalMlsIdForAgent(mlsConnectionId, userId, null);
		const externalId = this.state.newExternalId[mlsConnectionId][userId];

		const fieldHasError = _.get(this.state.mlsFieldsWithErrors, `[${mlsConnectionId}][${userId}]`);
		if (fieldHasError) {
			return false;
		}

		if (this.cleanMlsIdValue(externalId).length === 0) {
			return originalExternalId;
		} else {
			return originalExternalId === '' || originalExternalId !== externalId;
		}
	}

	onMLSFieldKeyPress(event, userId, mlsConnectionId) {
		if (event.key === 'Enter') {
			if (!this.isMLSSaveEnabled(userId, mlsConnectionId)) return;

			const value = this.state.newExternalId[mlsConnectionId][userId];
			const newExternalId = _.clone(this.state.newExternalId);
			newExternalId[mlsConnectionId][userId] = value;
	
			this.setState({ newExternalId }, () => {
				this.updateExternalIdForUser(userId, mlsConnectionId, value);
			});
		}
	}

	getApiErrorForUserAndConnection(userId, mlsConnectionId) {
		return this.props.mls.addingAgentMlsIdErrorId.find(
			user => user.userId === userId && user.mlsConnectionId === mlsConnectionId
		) ||
		this.props.mls.editingAgentMlsIdErrorId.find(
			user => user.userId === userId && user.mlsConnectionId === mlsConnectionId
		) ||
		this.props.mls.deletingAgentMlsIdErrorId.find(
			user => user.userId === userId && user.mlsConnectionId === mlsConnectionId
		);
	}

	resetPreviousAPIMessageFieldValue(exceptUserId) {
		const { mlsSystem } = this.state;
		const { mlsConnectionId } = mlsSystem;

		if (this.props.mls.addingAgentMlsIdErrorId.length ||
			this.props.mls.editingAgentMlsIdErrorId.length ||
			this.props.mls.deletingAgentMlsIdErrorId.length
		) {
			// clear any previous error message from API field
			const newExternalId = _.clone(this.state.newExternalId);
			
			let fousedFieldHasChanged = false;
			Object.keys(newExternalId[mlsConnectionId]).map(currentUserId => {
				
				const apiError = this.getApiErrorForUserAndConnection(currentUserId, mlsConnectionId);

				if (apiError) {
					const originalExternalIdValue = this.getOriginalMlsIdForAgent(mlsConnectionId, currentUserId);
					
					if (!exceptUserId || exceptUserId !== currentUserId) {
						newExternalId[mlsConnectionId][currentUserId] = originalExternalIdValue;
					}

					// don't clear error message if field with error is focused
					if (exceptUserId && exceptUserId === currentUserId) {

						if (originalExternalIdValue !== newExternalId[mlsConnectionId][currentUserId]) {
							fousedFieldHasChanged = true;
						}
					}						
				}
			});

			this.setState({ newExternalId });

			if (!exceptUserId || !fousedFieldHasChanged) {
				this.props.clearConnectMlsState();
			}
		}
	}

	onMLSFieldFocus(userId, mlsConnectionId) {
		if (_.get(this.state.focusedField, `[${mlsConnectionId}][${userId}]`)) return;
		if (!_.isEmpty(_.get(this.state.focusedField, `[${mlsConnectionId}]`))) {
			this.resetLastFocusedMLSField(true, true);
		} else {
			this.resetPreviousAPIMessageFieldValue(userId);
		}
		
		const focusedField = {};
		if (!focusedField[mlsConnectionId]) {
			focusedField[mlsConnectionId] = {};
		}
		focusedField[mlsConnectionId][userId] = true;
		this.setState({ focusedField });
	}

	onMLSFieldBlur(event) {
		if (event.key === 'Tab') {
			this.hideAllMlsFields(true);
		}
	}

	hideAllMlsFields(reset, keepFocused) {
		const shownMlsFields = _.clone(this.state.shownMlsFields);
		const { mlsSystem } = this.state;
		const { mlsConnectionId } = mlsSystem;

		if (keepFocused) {
			!_.isEmpty(_.get(shownMlsFields, `[${mlsConnectionId}]`)) &&
			Object.keys(shownMlsFields[mlsConnectionId])
				.map(currentUserId => {
					if (!_.get(this.state.focusedField, `[${mlsConnectionId}][${currentUserId}]`)) {
						delete shownMlsFields[mlsConnectionId][currentUserId];
					}
				});
		} else {
			shownMlsFields[this.state.mlsSystem.mlsConnectionId] = {};
		}
		
		this.setState({shownMlsFields});
		reset && this.resetLastFocusedMLSField(true, true);
	}

	resetLastFocusedMLSField(resetPreviousAPIMessageField, clearExternalIdState) {
		resetPreviousAPIMessageField && this.resetPreviousAPIMessageFieldValue();

		const { mlsSystem } = this.state;
		const { mlsConnectionId } = mlsSystem;

		const focusedField = _.clone(this.state.focusedField);

		focusedField[mlsConnectionId] && Object.keys(focusedField[mlsConnectionId]).map(currentUserId => {

			if (_.get(this.state.focusedField, `[${mlsConnectionId}][${currentUserId}]`)) {
				delete focusedField[mlsConnectionId][currentUserId];

				const shownMlsFields = _.clone(this.state.shownMlsFields);
				if (_.get(this.state.shownMlsFields, `[${mlsConnectionId}][${currentUserId}]`)) {
					delete shownMlsFields[mlsConnectionId][currentUserId];
				}

				const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);

				const originalExternalIdValue = this.getOriginalMlsIdForAgent(mlsConnectionId, currentUserId);

				const newExternalId = _.clone(this.state.newExternalId);
				newExternalId[mlsConnectionId][currentUserId] = originalExternalIdValue;

				if (_.get(this.state.mlsFieldsWithErrors, `[${mlsConnectionId}][${currentUserId}]`)) {
					delete mlsFieldsWithErrors[mlsConnectionId][currentUserId];
				}					

				this.setState({ newExternalId, focusedField, shownMlsFields, mlsFieldsWithErrors });
			}			
		});

		if (clearExternalIdState) {
			this.props.clearConnectMlsState();
		}
	}
	
	updateExternalIdForUser(userId, mlsConnectionId, newValue, forceAddition = false) {
		const originalExternalIdValue = this.getOriginalMlsIdForAgent(mlsConnectionId, userId);
		const agentMongoId = this.getMongoAgentId(mlsConnectionId, userId);

		const isEmptyString = this.cleanMlsIdValue(newValue).length === 0;

		if (newValue !== originalExternalIdValue) {
			const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);

			if (!updatingMlsIdForUsers[mlsConnectionId]) {
				updatingMlsIdForUsers[mlsConnectionId] = {};
			}
			updatingMlsIdForUsers[mlsConnectionId][userId] = true;
			this.setState({ updatingMlsIdForUsers, focusedField: {} });

			if (originalExternalIdValue) {
				if (isEmptyString) {
					this.props.deleteAgentMlsId(mlsConnectionId, userId, agentMongoId);
				} else {
					this.props.editAgentMlsId(mlsConnectionId, userId, newValue, agentMongoId, forceAddition);
				}
			} else {
				this.props.addAgentMlsId(mlsConnectionId, userId, newValue, forceAddition);
			}
		}
	}
}

ManageMlsAgentsModal.propTypes = {
	companies: PropTypes.object,
	mls: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	classes: PropTypes.object,
	email: PropTypes.string,
	showApiError: PropTypes.bool,
	company: PropTypes.object,
	user: PropTypes.object.isRequired,
	showErrorPopup: PropTypes.func.isRequired,
	selectedCompanyId: PropTypes.string,
	addOfficeId: PropTypes.func.isRequired,
	clearConnectMlsState: PropTypes.func.isRequired,
	clearErrorsForConnectionAndUser: PropTypes.func.isRequired,
	mlsConnectionId: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	connections: PropTypes.array,
	selfStartMlsIdsForUser: PropTypes.array,
	usersPage: PropTypes.bool,
	preselectUserId: PropTypes.string,
	currentUserEmail: PropTypes.string,
	settings: PropTypes.object,
	writeUserSettings: PropTypes.func.isRequired,
	addAgentMlsId: PropTypes.func.isRequired,
	deleteAgentMlsId: PropTypes.func.isRequired,
	editAgentMlsId: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
	modalShown: state.modal.modalShown,
	companies: state.companies,
	mls: state.mls,
	user: state.session.user,
	selectedCompanyId: state.companies.selectedId,
	currentUserEmail: state.session.user.mainEmail,
	settings: state.session.user.settings
});

const mapDispatchToProps = dispatch => bindActionCreators({
	writeUserSettings,
	hideModal,
	resetModal,
	showErrorPopup,
	addOfficeId,
	clearConnectMlsState,
	clearErrorsForConnectionAndUser,
	addAgentMlsId,
	deleteAgentMlsId,
	editAgentMlsId
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ManageMlsAgentsModal);


// WEBPACK FOOTER //
// ./src/components/Modal/ManageMlsAgentsModal.js